/*
  Infinite scroll for collection pages, powered by Ajaxinate (assets/ajaxinate.js).

  Implemented as a custom element because <product-facet> re-renders the whole
  #facet-main container after a filter/sort change: the old element disconnects
  (destroying its Ajaxinate instance) and the newly inserted one re-initializes
  against the fresh DOM automatically.
*/
(function () {
  if (window.customElements.get('infinite-scroll-pagination')) {
    return;
  }

  class InfiniteScrollPagination extends HTMLElement {
    connectedCallback() {
      requestAnimationFrame(() => {
        if (!this.isConnected || typeof window.Ajaxinate !== 'function') {
          return;
        }

        this.endlessScroll = new window.Ajaxinate({
          method: 'scroll',
          container: '#AjaxinateLoop',
          pagination: '#AjaxinatePagination',
          offset: parseInt(this.getAttribute('offset'), 10) || 600,
          loadingText: this.getAttribute('loading-text') || 'Loading',
          callback: this._onPageAppended.bind(this),
        });
      });
    }

    disconnectedCallback() {
      if (this.endlessScroll) {
        this.endlessScroll.destroy();
        this.endlessScroll = null;
      }
    }

    _onPageAppended() {
      // Appended items are not part of product-list's stagger apparition
      // animation, so the [reveal] { opacity: 0 } rule would keep them
      // invisible forever.
      document.querySelectorAll('#AjaxinateLoop product-item[reveal]').forEach((item) => {
        item.removeAttribute('reveal');
      });
    }
  }

  window.customElements.define('infinite-scroll-pagination', InfiniteScrollPagination);
})();
